// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.searchInMiddle {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 2rem;
  gap: 2rem;
}
@media only screen and (max-width: 56.25em) {
  .searchInMiddle {
    flex-direction: column;
    align-items: center;
  }
  .searchInMiddle_filter {
    order: 2;
  }
  .searchInMiddle_search {
    order: 1;
  }
}

.modal {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
}
.modal__beside {
  display: flex;
  width: 38rem;
  justify-content: space-between;
}
.modal__beside__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-bottom: 2rem;
}
.modal__checks {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}
.modal__checks_group {
  align-self: center;
}

.whiteTable {
  width: 100%;
  margin-top: 3rem;
  font-size: 1.2rem;
  overflow-y: auto;
  overflow-x: auto;
}
.whiteTable::-webkit-scrollbar:horizontal {
  width: 0;
  height: 0.7rem;
  background: var(--color-white);
}
.whiteTable::-webkit-scrollbar-thumb:horizontal {
  background: var(--color-grey);
  border-radius: 2rem;
}
.whiteTable::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 3rem 3rem 0;
}
.whiteTable::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 3rem;
}
.whiteTable table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
}
.whiteTable table tr {
  padding: 0 1rem;
  align-items: center;
}
.whiteTable table th,
.whiteTable table td {
  padding: 1.2rem 2rem;
}
.whiteTable table th {
  font-weight: 700;
}
.whiteTable table thead tr {
  background-color: var(--color-dark);
  border-radius: 1rem;
  color: var(--color-white);
  position: sticky;
  top: 0;
  z-index: 50;
}
.whiteTable table tbody tr {
  background-color: var(--color-white);
}
.whiteTable table tbody tr:nth-child(even) {
  background-color: var(--color-table-grey);
}
.whiteTable table .action__text {
  font-weight: 600;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
}
.whiteTable table .action__icons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 2.4rem;
}
.whiteTable table .action__icons > * {
  cursor: pointer;
  position: relative;
}
.whiteTable table .action__icons > *:hover {
  color: var(--color-primary);
}
.whiteTable table .action__icons > * > :last-child {
  opacity: 0;
}
.whiteTable table .action__icons > * > :last-child:hover {
  opacity: 1;
}
.whiteTable table .action__icons > :not(last-child) {
  margin-right: 0.5rem;
}
.whiteTable table .action__details {
  font-size: 1rem;
  color: var(--color-white);
  padding: 0.8rem;
  background-color: rgba(0, 60, 151, 0.7);
  border-radius: 1rem;
  position: absolute;
  top: -0.7rem;
  left: -1.5rem;
}
.whiteTable table img {
  width: 5rem;
}

.tableStatus {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  width: 85%;
  font-size: 1rem;
  padding: 1.2rem 2rem;
}
.tableStatus__red {
  background-color: var(--color-error);
  color: var(--color-white);
}
.tableStatus__green {
  background-color: var(--color-green);
  color: var(--color-white);
}
.tableStatus__yellow {
  background-color: var(--color-yellow);
  color: var(--color-dark);
}
.tableStatus__dark {
  background-color: var(--color-dark);
  color: var(--color-white);
}

.filter_content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.filter_content > :not(last-child) {
  margin-right: 1rem;
}

.noInsights {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-error);
  font-size: var(--default-font-subtitle);
  text-align: center;
  height: 70%;
}

ul.custom-list li {
  display: flex;
  list-style-type: none;
  margin: 1rem;
  font-size: 14px;
  color: var(--color-dark);
}

ul.custom-list li:before {
  content: "✓";
  margin-right: 0.5em;
  font-weight: 700;
  color: var(--color-primary);
}

.gridTable {
  width: 100%;
  margin-top: 3rem;
  font-size: 1.6rem;
  overflow-y: auto;
  padding: 4rem 2rem;
}
.gridTable table {
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: center;
  width: 100%;
  max-width: 100%;
  border: none;
}
.gridTable tbody {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 2rem;
  width: 100%;
}
@media only screen and (max-width: 75em) {
  .gridTable tbody {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media only screen and (max-width: 62.5em) {
  .gridTable tbody {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .gridTable tbody {
    grid-template-columns: repeat(2, 1fr);
  }
}
.gridTable tr {
  display: grid;
  grid-template-columns: 100%;
  justify-items: center;
  gap: 2rem;
  background-color: var(--color-white);
  border-radius: 2rem;
  position: relative;
  padding: 0 0 2rem 0;
}
.gridTable td > * {
  margin: 0 2rem;
}
.gridTable td {
  width: 100%;
}
.gridTable td img {
  height: 25rem;
  width: 100%;
  object-fit: cover;
  top: 0;
  left: 0;
  margin: 0;
  border-radius: 2rem 2rem 0 0;
}

.active {
  background-color: #007bff;
  color: #ffffff;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Global/GlobalStyles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACC,aAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;AAAD;AAEC;EAPD;IAQE,sBAAA;IACA,mBAAA;EACA;EACA;IACC,QAAA;EACD;EAEA;IACC,QAAA;EAAD;AACF;;AAIA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AADD;AAGC;EACC,aAAA;EACA,YAAA;EACA,8BAAA;AADF;AAGE;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AADH;AAKC;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AAHF;AAKE;EACC,kBAAA;AAHH;;AAQA;EACC,WAAA;EAEA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAND;AAQC;EACC,QAAA;EACA,cAAA;EACA,8BAAA;AANF;AASC;EACC,6BAAA;EACA,mBAAA;AAPF;AAUC;EACC,WAAA;EACA,oCAAA;EACA,4BAAA;AARF;AAWC;EACC,mCAAA;EACA,mBAAA;AATF;AAYC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAVF;AAaE;EACC,eAAA;EACA,mBAAA;AAXH;AAcE;;EAEC,oBAAA;AAZH;AAeE;EACC,gBAAA;AAbH;AAkBG;EACC,mCAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAhBJ;AAqBG;EACC,oCAAA;AAnBJ;AAqBI;EACC,yCAAA;AAnBL;AAyBG;EACC,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;AAvBJ;AA0BG;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;AAxBJ;AA0BI;EACC,eAAA;EACA,kBAAA;AAxBL;AA0BK;EACC,2BAAA;AAxBN;AA2BK;EACC,UAAA;AAzBN;AA2BM;EACC,UAAA;AAzBP;AA8BI;EACC,oBAAA;AA5BL;AAgCG;EACC,eAAA;EACA,yBAAA;EACA,eAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AA9BJ;AAkCE;EACC,WAAA;AAhCH;;AAqCA;EACC,aAAA;EAEA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;AAnCD;AAqCC;EACC,oCAAA;EACA,yBAAA;AAnCF;AAsCC;EACC,oCAAA;EACA,yBAAA;AApCF;AAuCC;EACC,qCAAA;EACA,wBAAA;AArCF;AAwCC;EACC,mCAAA;EACA,yBAAA;AAtCF;;AA2CC;EACC,aAAA;EACA,eAAA;EACA,mBAAA;AAxCF;AA0CE;EACC,kBAAA;AAxCH;;AA6CA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,WAAA;AA1CD;;AA6CA;EACC,aAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;AA1CD;;AA6CA;EACC,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;AA1CD;;AA6CA;EACC,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA1CD;AA4CC;EACC,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AA1CF;AA6CC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;AA3CF;AA6CE;EAND;IAOE,qCAAA;EA1CD;AACF;AA4CE;EAVD;IAWE,qCAAA;EAzCD;AACF;AA2CE;EAdD;IAeE,qCAAA;EAxCD;AACF;AA2CC;EACC,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,SAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAzCF;AA6CE;EACC,cAAA;AA3CH;AAyCC;EAKC,WAAA;AA3CF;AA6CE;EACC,aAAA;EACA,WAAA;EACA,iBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,4BAAA;AA3CH;;AA+CA;EACC,yBAAA;EACA,cAAA;EACA,eAAA;AA5CD","sourcesContent":["@import '../variables/breakpoints';\n\n.searchInMiddle {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n\tmargin-top: 2rem;\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-900) {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t&_filter {\n\t\t\torder: 2;\n\t\t}\n\n\t\t&_search {\n\t\t\torder: 1;\n\t\t}\n\t}\n}\n\n.modal {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\twidth: 38rem;\n\t\tjustify-content: space-between;\n\n\t\t&__grid {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t\tgap: 2rem;\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\t}\n\n\t&__checks {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: 1rem 0 2rem 0;\n\n\t\t&_group {\n\t\t\talign-self: center;\n\t\t}\n\t}\n}\n\n.whiteTable {\n\twidth: 100%;\n\t// max-height: 100vh;\n\tmargin-top: 3rem;\n\tfont-size: 1.2rem;\n\toverflow-y: auto;\n\toverflow-x: auto;\n\n\t&::-webkit-scrollbar:horizontal {\n\t\twidth: 0;\n\t\theight: 0.7rem;\n\t\tbackground: var(--color-white);\n\t}\n\n\t&::-webkit-scrollbar-thumb:horizontal {\n\t\tbackground: var(--color-grey);\n\t\tborder-radius: 2rem;\n\t}\n\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 0 3rem 3rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 3rem;\n\t}\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: left;\n\t\t// margin-top: 2rem;\n\n\t\ttr {\n\t\t\tpadding: 0 1rem;\n\t\t\talign-items: center;\n\t\t}\n\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 1.2rem 2rem;\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tthead {\n\t\t\t// margin-bottom: 2rem;\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-dark);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tposition: sticky;\n\t\t\t\ttop: 0;\n\t\t\t\tz-index: 50;\n\t\t\t}\n\t\t}\n\n\t\ttbody {\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-white);\n\n\t\t\t\t&:nth-child(even) {\n\t\t\t\t\tbackground-color: var(--color-table-grey);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.action {\n\t\t\t&__text {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\ttext-decoration: underline;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t&__icons {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tfont-size: 2.4rem;\n\n\t\t\t\t& > * {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tposition: relative;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t\t}\n\n\t\t\t\t\t& > :last-child {\n\t\t\t\t\t\topacity: 0;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t& > :not(last-child) {\n\t\t\t\t\tmargin-right: 0.5rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&__details {\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tpadding: 0.8rem;\n\t\t\t\tbackground-color: rgba(#003c97, 0.7);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -0.7rem;\n\t\t\t\tleft: -1.5rem;\n\t\t\t}\n\t\t}\n\n\t\timg {\n\t\t\twidth: 5rem;\n\t\t}\n\t}\n}\n\n.tableStatus {\n\tdisplay: flex;\n\t// font-weight: 700;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 1rem;\n\twidth: 85%;\n\tfont-size: 1rem;\n\tpadding: 1.2rem 2rem;\n\n\t&__red {\n\t\tbackground-color: var(--color-error);\n\t\tcolor: var(--color-white);\n\t}\n\n\t&__green {\n\t\tbackground-color: var(--color-green);\n\t\tcolor: var(--color-white);\n\t}\n\n\t&__yellow {\n\t\tbackground-color: var(--color-yellow);\n\t\tcolor: var(--color-dark);\n\t}\n\n\t&__dark {\n\t\tbackground-color: var(--color-dark);\n\t\tcolor: var(--color-white);\n\t}\n}\n\n.filter {\n\t&_content {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\n\t\t& > :not(last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n}\n\n.noInsights {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--color-error);\n\tfont-size: var(--default-font-subtitle);\n\ttext-align: center;\n\theight: 70%;\n}\n\nul.custom-list li {\n\tdisplay: flex;\n\tlist-style-type: none;\n\tmargin: 1rem;\n\tfont-size: 14px;\n\tcolor: var(--color-dark);\n}\n\nul.custom-list li:before {\n\tcontent: '✓';\n\tmargin-right: 0.5em;\n\tfont-weight: 700;\n\tcolor: var(--color-primary);\n}\n\n.gridTable {\n\twidth: 100%;\n\tmargin-top: 3rem;\n\tfont-size: 1.6rem;\n\toverflow-y: auto;\n\tpadding: 4rem 2rem;\n\n\ttable {\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: center;\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t}\n\n\ttbody {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(5, 1fr);\n\t\tgap: 2rem;\n\t\twidth: 100%;\n\n\t\t@media only screen and (max-width: $bp-1200) {\n\t\t\tgrid-template-columns: repeat(4, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\t}\n\n\ttr {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 100%;\n\t\tjustify-items: center;\n\t\tgap: 2rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 2rem;\n\t\tposition: relative;\n\t\tpadding: 0 0 2rem 0;\n\t}\n\n\ttd {\n\t\t& > * {\n\t\t\tmargin: 0 2rem;\n\t\t}\n\n\t\twidth: 100%;\n\n\t\timg {\n\t\t\theight: 25rem;\n\t\t\twidth: 100%;\n\t\t\tobject-fit: cover;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tmargin: 0;\n\t\t\tborder-radius: 2rem 2rem 0 0;\n\t\t}\n\t}\n}\n.active {\n\tbackground-color: #007bff;\n\tcolor: #ffffff;\n\tcursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
